import { createSlice } from '@reduxjs/toolkit';
import { BookmarkedItems, LayoutStateProps } from '../../../types/Layout';
import { bookMarks } from '../../../data/layout/Header';
const loadPinned = (): string[] => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem('pinned');
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};
const initialState: LayoutStateProps = {
  pinedMenu: loadPinned(),
  responsiveSearch: false,
  linkItemsArray: [],
  flip: false,
  bookmarkedData: [...bookMarks],
};

const LayoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setPinedMenu: (state, action) => {
      state.pinedMenu = action.payload;
      localStorage.setItem('pinned', JSON.stringify(action.payload));
    },
    setResponsiveSearch: (state) => {
      state.responsiveSearch = !state.responsiveSearch;
    },
    clearPinned: (state) => {
      state.pinedMenu = [];
    },
    getLinkItemsArray: (state, action) => {
      state.linkItemsArray = action.payload;
    },
    setFlip: (state) => {
      state.flip = !state.flip;
    },
    handleBookmarkChange: (state, action) => {
      if (!action.payload.bookmarked) {
        state.bookmarkedData.push({ ...action.payload, bookmarked: !action.payload.bookmarked });
      } else {
        const tempt: BookmarkedItems[] = [];
        state.bookmarkedData.forEach((ele) => {
          if (ele.id !== action.payload.id) {
            tempt.push(ele);
          }
        });
        state.bookmarkedData = tempt;
      }
      const temp = [...state.linkItemsArray];
      temp.splice(action.payload.id - 1, 1, {
        ...action.payload,
        bookmarked: !action.payload.bookmarked,
      });
      state.linkItemsArray = temp;
    },
  },
});

export const {
  setPinedMenu,
  setResponsiveSearch,
  getLinkItemsArray,
  setFlip,
  handleBookmarkChange,
  clearPinned,
} = LayoutSlice.actions;
export default LayoutSlice.reducer;
